import React, { Component } from "react";
import { reportsList } from "./Configs/reportsList";
import "./index.scss";
import FilterView from "./Components/filterView";
import BackIcon from "./svgs/backIcon.svg";
import { Collapse } from "@material-ui/core";
import AxiosClient from "../../Network/AxiosClient";
import { report_tabs } from "./Configs/filterConfigs";
import ArrowRightIcon from "./svgs/arrow-right.svg";
import SearchBar from "./Components/searchBar";
import { format, subDays } from "date-fns";
import { Redirect } from "react-router-dom";
import { filterByUserScope } from "../../utilities/helpers";
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
function formatWords(str) {
  var newString = str.replace(/_/g, " ");
  return capitalizeFirstLetter(newString);
}

const formatParsingDate = (statusArray, key) => {
  if (!key) return "";
  if (statusArray[key]) {
    const timeStamp = statusArray[key].last_parsed;
    if (!timeStamp) return "";
    return `Updated till - ${format(
      subDays(new Date(timeStamp), 1),
      "cccc, MMMM dd"
    )}`;
  }
  return "";
};
export default class NewReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      filter: null,
      currentReport: null,
      showFilter: true,
      tableData: [],
      currentGroup: "",
      searchTerm: "",
      filterConfigs: {},
      parserStatus: {},
      filteredReportTabs: [],
    };
  }

  componentDidMount() {
    this.setState(() => {
      const filteredTabs = this.getFilteredReportTabs();
      return {
        filteredReportTabs: filteredTabs,
        currentGroup: filteredTabs[0],
      };
    });
    const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
    if (localUserToken) {
      this.getFiltereData();
      this.getParserStatus();
    }
  }

  getFiltereData = () => {
    AxiosClient.get(
      `${process.env.REACT_APP_API_REPORT}/api/reports/v3/report-filters`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      }
    )
      .then((res) => {
        //console.log(res.data);
        this.setState({ filterConfigs: res.data });
        //console.log(res.data.fields);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getParserStatus = () => {
    AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/reports/v3/parser-status`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      }
    )
      .then((res) => {
        //console.log(res.data);
        this.setState({ parserStatus: res.data });
        //console.log(res.data.fields);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  toggleDrawer = (report) => {
    this.setState((prevState) => ({
      currentReport: prevState.currentReport
        ? null
        : {
            ...report,
            fields: prevState.filterConfigs[report.key],
            parserStatus: prevState.parserStatus[report.key],
          },
    }));
  };

  getReportKey = (report) => {
    var x = "";
    if (report) {
      x = report.url.replace(`/api/reports/v`, "");
      x = x.replace(/[0-9]/g, "");
      x = x.replace("/", "");
      //console.log(x);
      return x;
    }
    return null;
  };
  toggleFilter = () => {
    this.setState((prevState) => ({ showFilter: !prevState.showFilter }));
  };

  onChangeGroup = (tab) => {
    this.setState({ currentGroup: tab });
  };

  filterCurrentGroup = (report) => {
    const user_scope = localStorage.getItem("scope");
    if (user_scope === "online") return true;
    if (this.state.currentGroup === "all") return true;
    return report.group && report.group === this.state.currentGroup;
  };
  filterSearchTerm = (report) => {
    if (this.state.searchTerm === "") return true;
    return report.name.toLowerCase().includes(this.state.searchTerm);
  };
  onSearch = (e) => {
    this.setState({ searchTerm: e.target.value });
  };

  getFilteredReportTabs = () => {
    const filteredTabs = report_tabs.filter(filterByUserScope);
    return filteredTabs.map((tab) => tab.name);
  };

  render() {
    const isOpen = this.state.currentReport ? true : false;
    const fields = this.state.filterConfigs;
    const user_scope = localStorage.getItem("scope");

    const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
    if (!localUserToken) return <Redirect to="/signin" />;
    return (
      <div className="main-container new-report-container">
        {/* <div className="page-title">Reports</div> */}
        <ReportTabInfo
          report={this.state.currentReport}
          onBack={this.toggleDrawer}
          parserStatus={this.state.parserStatus}
        />
        <div className="report-layout">
          <div className="reports-list-container">
            <div className="reports-list-top-bar">
              <SearchBar
                value={this.state.searchTerm}
                onChange={this.onSearch}
              />
              {user_scope === "merchant_business" && (
                <ReportGroups
                  tabs={this.state.filteredReportTabs}
                  current={this.state.currentGroup}
                  onChange={this.onChangeGroup}
                />
              )}
            </div>
            {reportsList
              .filter(filterByUserScope)
              .filter(this.filterCurrentGroup)
              .filter(this.filterSearchTerm)
              .map((report, index) => (
                <div
                  className={
                    fields.hasOwnProperty(report.key)
                      ? "individual-report"
                      : "individual-report disabled"
                  }
                  key={report.name}
                  onClick={() =>
                    fields.hasOwnProperty(report.key) &&
                    this.toggleDrawer({ ...report, index: index })
                  }
                >
                  <div className="report-index">
                    {String(index + 1).padStart(2, "0")}
                  </div>
                  <div>
                    <h4>{report.name}</h4>
                    <p>
                      {formatParsingDate(this.state.parserStatus, report.key)}
                    </p>
                    {/* <button onClick={this.toggleDrawer}>→</button> */}
                  </div>

                  <img src={ArrowRightIcon} alt="Arrow Right" />
                </div>
              ))}
          </div>
          <div
            className="report-overlay"
            style={{
              left: isOpen ? 0 : "100%",
            }}
          >
            <FilterView
              callBack={(f) => this.setState({ filter: f })}
              report={this.state.currentReport}
            />
          </div>
        </div>
      </div>
    );
  }
}

function ReportGroups({ tabs, current, onChange }) {
  return (
    <div className="report-group-tabs">
      {tabs.map((tab) => (
        <button
          disabled={!reportsList.find((r) => r.group === tab || tab === "all")}
          className={tab === current ? "active" : ""}
          key={tab}
          onClick={() => onChange(tab)}
        >
          <p>{formatWords(tab)}</p>
        </button>
      ))}
    </div>
  );
}

function ReportTabInfo({ report, onBack, parserStatus }) {
  return (
    <div className="page-title">
      {report && (
        <Collapse in={report ? true : false}>
          <div className="page-title-container">
            <button onClick={onBack}>
              <img src={BackIcon} alt="Back" />
            </button>
            {report && (
              <div className="report-id report-index">
                {String(report.index + 1).padStart(2, "0")}.
              </div>
            )}
          </div>
        </Collapse>
      )}
      <div className="title-and-date">
        {" "}
        {report ? report.name : "Reports"}
        {report && report.key === "assisted-ekyc-report" && (
          <p>This report can be downloaded for 30 days only</p>
        )}
        <p>{report ? formatParsingDate(parserStatus, report.key) : ""}</p>
      </div>
    </div>
  );
}
